import React, { useState, useMemo } from "react"
import Select from 'react-select';
import Helper from "../../helper";
import Application from "../../services/application.service";

const Investment = (props) => {
    var inputProp = props.input;

    const [fundSelect, setFundSelect] = useState(null);
    const fundList = [
        { value: 'Savings', label: 'Savings' },
        { value: 'Retirement/Insurance Payout', label: 'Retirement/Insurance Payout' },
        { value: 'Passive Income (rental, dividends, interest)', label: 'Passive Income (rental, dividends, interest)' },
        { value: 'Trade/Business', label: 'Trade/Business' },
        { value: 'Sale of Assets', label: 'Sale of Assets' },
        { value: 'Winnings', label: 'Winnings' },
        { value: 'Gifts/Inheritance/Donations', label: 'Gifts/Inheritance/Donations' },
        { value: 'Child/Spouse support Payments', label: 'Child/Spouse support Payments' },
        { value: 'Salary/Bonus', label: 'Salary/Bonus' },
        { value: 'Tax Refund', label: 'Tax Refund' },
        { value: 'Other', label: 'Other' },
    ];

    const [input, setInput] = useState({
        lump_sum_amount: inputProp.debit_order,
        month_debit_amount: inputProp.amount,
        source_fund_invested: inputProp.source_of_fund,
        other_fund_invested: inputProp.other_fund_source,
        domenstic_prominent: inputProp.is_domenstic_prominent ?? 'N',
        domenstic_details: inputProp.domenstic_details
    });

    useMemo(() => {
        setFundSelect(Helper.findByValue(inputProp.source_of_fund, fundList))
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        var dt = { ...inputProp, ...input };
        dt.source_fund_invested = fundSelect && fundSelect.value ? fundSelect.value : '';
        dt.domenstic_prominent = input.domenstic_prominent;

        var formData = Helper.convertFormData(dt);
        formData.append('step', 'investment');

        Application.applicationUpdate(formData).then(res => {
            if (res.success === true) {
                props.setFormCount(5);
            }
        }).catch(err => console.log(err));
    }

    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Investment Details </h2>
                </div>
                <div className="form-fields">
                    <div className="sub-form">
                        <h5 className="text-title">Investment Amount</h5>
                        <p className="text-description">You can invest a lump -Sum amount and/or indicate a monthly debit order amount.</p>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Lump-Sum Amount <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <input type="number" className="form-control" min="1" id="lump_sum_amount" name="lump_sum_amount" value={input.lump_sum_amount} onChange={handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Monthly Debit Amount <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <input type="number" className="form-control" id="month_debit_amount" name="month_debit_amount" min="1" value={input.month_debit_amount} onChange={handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <label htmlFor="name">Source of Funds Invested <span className="asterisk">*</span></label>
                                <div className="input-wrap d-flex">
                                    <Select name="source_fund_invested" options={fundList} value={fundSelect} onChange={val => setFundSelect(val)} placeholder={'Select'}></Select>
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            {(fundSelect && fundSelect.value == 'other') &&
                                <div className="col-lg-6 col-md-12 form-group">
                                    <label htmlFor="name">Other <span className="asterisk">*</span></label>
                                    <div className="input-wrap d-flex">
                                        <input type="text" className="form-control" name="other_fund_invested" value={input.other_fund_invested} onChange={handleChange} />
                                    </div>
                                    <div className="validationAlert"></div>
                                </div>
                            }
                        </div>
                        <p className="note-info-light">(e.g., salary; investment proceeds; sale of assets; inheritance, etc.) the Manager reserves the right to request a documentary proof, e.g., income statement, bank statement.  </p>
                    </div>
                    <div className="sub-form">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 form-group form-radio-alter">
                                <label>I consider myself to be, or to be associated with, a Domestic Prominent Influential Person or a Foreign Prominent Public Official.</label>
                                <div className="d-flex align-items-center form-radio-wrapper">
                                    <div className="form-check pr-4">
                                        <input className="form-check-input" value="Y" type="radio" name="domenstic_prominent" id="domenstic_prominent_Y" onChange={handleChange} checked={input.domenstic_prominent === 'Y'} />
                                        <label className="form-check-label pl-2" htmlFor="domenstic_prominent_Y"> Yes </label>
                                    </div>
                                    <div className="form-check pr-4">
                                        <input className="form-check-input" value="N" type="radio" name="domenstic_prominent" id="domenstic_prominent_N" onChange={handleChange} checked={input.domenstic_prominent == 'N'} />
                                        <label className="form-check-label pl-2" htmlFor="domenstic_prominent_N"> No </label>
                                    </div>
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                            {input.domenstic_prominent === 'Y' &&
                                <div className="col-12 form-group">
                                    <label htmlFor="name">Please provide details: <span className="asterisk">*</span></label>
                                    <div className="input-wrap d-flex">
                                        <textarea className="form-control" rows='4' name="domenstic_details" value={input.domenstic_details} onChange={handleChange}></textarea>
                                    </div>
                                    <div className="validationAlert"></div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper ">
                            <button type="button" className="btn btn-ouline" onClick={e => props.setFormCount(3)} >Back</button>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Investment;